import { createFileRoute } from '@tanstack/react-router';
import { PatientHistoryPageContent } from '@/components/paciente/PacienteClinicalPages';

export const Route = createFileRoute('/pep-vida/_authed/pacientes/$cdPaciente/historico')({
  component: HistoricoPacientePage,
});

function HistoricoPacientePage() {
  const { cdPaciente } = Route.useParams();
  return <PatientHistoryPageContent cdPaciente={Number(cdPaciente)} />;
}
